import * as React from "react";

function BlockchainSvg(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} viewBox="0 0 40 40" {...props}>
      <g fill="none" stroke="#fff" strokeWidth={2}>
        <rect width={10} height={10} x={5} y={5} rx={2} />
        <rect width={10} height={10} x={25} y={5} rx={2} />
        <rect width={10} height={10} x={5} y={25} rx={2} />
        <rect width={10} height={10} x={25} y={25} rx={2} />
        <path d="M10 10h20M10 30h20M10 10v20M30 10v20" />
      </g>
    </svg>
  );
}

export default BlockchainSvg;
